import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { ToastService } from '../../services/toast/toast.service';

export interface SelectBranchModalData {
  branches: Array<{ id: string; name: string }>;
  /** Quando true, o botao Cancelar e ocultado (contexto de primeiro login) */
  mandatory?: boolean;
}

@Component({
  selector: 'app-select-branch-modal',
  templateUrl: './select-branch-modal.component.html',
  styleUrls: ['./select-branch-modal.component.sass'],
})
export class SelectBranchModalComponent {
  branches: Array<{ id: string; name: string }> = [];
  mandatory = false;
  selectedBranchId: string | null = null;
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<SelectBranchModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectBranchModalData,
    private authService: AuthService,
    private toastService: ToastService
  ) {
    this.branches = data?.branches || [];
    this.mandatory = !!data?.mandatory;

    // Nao permite fechar clicando fora se obrigatorio (primeiro login)
    if (this.mandatory) {
      this.dialogRef.disableClose = true;
    }
  }

  onConfirm(): void {
    if (!this.selectedBranchId || this.loading) {
      return;
    }

    this.loading = true;
    this.authService
      .selectBranch(this.selectedBranchId)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading = false;
          this.dialogRef.close(this.selectedBranchId);
        },
        error: (err: any) => {
          this.loading = false;
          const msg = err?.error?.message || 'Erro ao selecionar filial.';
          this.toastService.showError(msg);
        },
      });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
